import { render, staticRenderFns } from "./delicacy.vue?vue&type=template&id=070d991c&"
import script from "./delicacy.vue?vue&type=script&lang=js&"
export * from "./delicacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports